import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { SiteProvider } from "@/context/SiteContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";

import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import SetPassword from "@/pages/SetPassword";
import PaymentSuccess from "@/pages/PaymentSuccess";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import BusinessDashboard from "@/pages/business/BusinessDashboard";
import ClientPortal from "@/pages/client/ClientPortal";
import DriverDashboard from "@/pages/driver/DriverDashboard";

function App() {
  return (
    <div className="App">
      <SiteProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Auth mode="login" />} />
              <Route path="/register" element={<Auth mode="register" />} />
              <Route path="/set-password" element={<SetPassword />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/admin" element={<ProtectedRoute roles={["admin"]}><AdminDashboard /></ProtectedRoute>} />
              <Route path="/business" element={<ProtectedRoute roles={["business"]}><BusinessDashboard /></ProtectedRoute>} />
              <Route path="/portal" element={<ProtectedRoute roles={["client"]}><ClientPortal /></ProtectedRoute>} />
              <Route path="/driver" element={<ProtectedRoute roles={["driver"]}><DriverDashboard /></ProtectedRoute>} />
            </Routes>
            <Toaster position="top-right" richColors />
          </BrowserRouter>
        </AuthProvider>
      </SiteProvider>
    </div>
  );
}

export default App;
